import { render } from "./PaginationDetail.vue?vue&type=template&id=518ca02a"
import script from "./PaginationDetail.vue?vue&type=script&lang=js"
export * from "./PaginationDetail.vue?vue&type=script&lang=js"

import "./PaginationDetail.vue?vue&type=style&index=0&id=518ca02a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__